<template>
    <div>
        <div style="background-color: rgba(255, 215, 3, 0.9)">
            <div class=" ">
                <div class="uk-child-width-1-1@m" uk-grid >
                    <div style="padding: 0px !important;">
                        <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow="ratio: 7:2; animation: push">

                            <ul class="uk-slideshow-items">
                                <li>
                                    <img src="/alum2.jpg" alt="" uk-cover>
                                    <div class="uk-overlay uk-overlay-primary  uk-position-cover" style="background: rgba(34,34,34,.5)">
                                        <div class="" style="margin-top: 20% !important;">
                                            <div class="uk-container ">
                                                <h1  class="uk-heading-medium  uk-light">Alumni </h1>
                                                <!--<p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                                            </div>
                                        </div>
                                    </div>
                                </li>

                            </ul>

                            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

                        </div>
                    </div>
                    <!---->

                </div>
                <!--<div >
                    <div class="uk-align-center ">
                        &lt;!&ndash;<h2 class="uk-heading-small uk-text-center" style="font-family: 'Nanum Gothic', sans-serif;">
                            <span class="half-a-border-on-top ">Alumni </span>
                        </h2>&ndash;&gt;

                    </div>
                </div>-->
            </div>

        </div>
        <div class="uk-padding-large">
            <div class="uk-container">
                <div class="">
                    <h3>Welcome to The Northern Caribbean University Alumni Association</h3>
                    <p>
                        The principal objective of the Alumni Association is to mobilize the full strength of organized alumni
                        through active participation in support of the educational programme in all its spiritual, intellectual,
                        physical, moral, financial and social endeavours.
                        <br><br>
                        Membership in the Northern Caribbean University Alumni Association is free
                        and automatic upon completion of any degree from Northern Caribbean University.
                        This membership provides you with the opportunity to serve as an alumnus and help others
                        to have the same opportunities that this degree has opened you to.

                    </p>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AlumniWelcomeBg"
    }
</script>

<style scoped>
    .half-a-border-on-top {
        border-bottom: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 1px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
    //background-color: rgba(255, 215, 3,0.3);
        position: absolute;
        right:0;
        top:-2px;
    }
    h1{

        font-style: normal;
    }
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }

        p,li{
            font-size: 0.8em !important;
        }


    }
</style>
